// Report layouts as the API returns them (GET/POST/PUT/DELETE /layouts): { id, name, active, shared,
// owner: { id, name, initials } | null, can_edit, definition: { fields: [trial field keys, in report
// column order] } }. A private layout is only its owner's; a shared one everyone can use. Only the
// owner or an admin can change or delete it (can_edit).

/** "Name (INI)" of the layout's owner, or '' for shared layouts without owner (admin-managed). */
export function ownerLabel(layout) {
  const owner = layout?.owner;
  if (!owner || typeof owner !== 'object') return '';
  return owner.initials ? `${owner.name} (${owner.initials})` : owner.name ?? '';
}

/**
 * The layout's field keys in order. Tolerates a definition sent as a JSON string or in the old
 * { fieldlist: [{ field }] } shape, and never throws (a broken definition gives no fields).
 */
export function parseLayoutFields(layout) {
  let definition = layout?.definition;
  if (typeof definition === 'string') {
    try {
      definition = JSON.parse(definition);
    } catch {
      return [];
    }
  }
  const fields = definition?.fields ?? (definition?.fieldlist ?? []).map((row) => row?.field);
  return Array.isArray(fields) ? fields.filter((f) => typeof f === 'string' && f !== '') : [];
}

/**
 * A message for a failed layout request: the API's own message for validation errors (422, e.g. a
 * duplicate name), a generic one otherwise - a 500's message is a raw exception, not for users.
 */
export function layoutErrorMessage(err, action) {
  const status = err?.response?.status;
  if (status === 422 && err.response.data?.message) return err.response.data.message;
  if (status === 403) return `You are not allowed to ${action} this layout.`;
  if (status === 404) return 'This layout no longer exists. Reload the page.';
  return `Could not ${action} the layout${status ? ` (server error ${status})` : ' (no connection)'}. Please try again.`;
}
